import { getDocumentFields } from "./documentFieldPayload";
import { getSpecialForm } from "../components/permitForms/specialFormsMap";
import { mergePermitGroupOverrides } from "./fieldSettings";

const normalizeFieldType = (fieldType) => {
  if (!fieldType) return "text";

  const fieldTypeMap = {
    checkboxGroup: "checkboxGroup",
    selectGroup: "selectGroup",
  };

  return fieldTypeMap[fieldType] || fieldType;
};

const normalizeOptions = (options = []) => {
  if (!Array.isArray(options)) {
    return [];
  }

  return options.map((option) => ({
    ...option,
    value:
      option?.field_id ?? option?.value ?? option?.name ?? option?.label ?? "",
  }));
};

const normalizeField = (field, parentSection) => {
  const normalizedType = normalizeFieldType(field?.field_type);

  return {
    ...field,
    section: field?.section ?? parentSection,
    type: normalizedType,
    field_label: field?.field_label ?? field?.label,
    title: field?.label,
    options: normalizeOptions(field?.options),
  };
};

const buildValuesMap = (fields = []) => {
  return fields.reduce((acc, field) => {
    if (!field?.name) {
      return acc;
    }

    if (field.type === "checkbox" && Array.isArray(field?.value)) {
      acc[field.name] = field.value;
      return acc;
    }

    acc[field.name] = field?.value ?? "";
    return acc;
  }, {});
};

export const loadInitials = async (selectedDocument, documents = {}) => {
  const specialForm = getSpecialForm(selectedDocument);
  if (specialForm?.loadInitials) {
    return specialForm.loadInitials();
  }

  if (!selectedDocument?.form_id) {
    return [];
  }

  const documentConfig = documents?.[selectedDocument.form_id];

  if (!documentConfig) {
    return [];
  }

  const rawFields = getDocumentFields(documentConfig);
  const parentSections = Array.isArray(documentConfig?.sections)
    ? documentConfig.sections.flatMap((section) =>
        Array.isArray(section?.fields)
          ? section.fields.map(() => section?.section)
          : [],
      )
    : [];
  const fields = mergePermitGroupOverrides(
    rawFields.map((field, index) =>
      normalizeField(field, parentSections[index]),
    ),
  );

  const values = buildValuesMap(fields);

  return [
    {
      fields,
      values,
    },
  ];
};
